import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { LayoutService } from 'src/app/layout/layout.service';

@Component({
  selector: 'app-service-near-payin',
  templateUrl: './service-near-payin.component.html',
  styleUrls: ['./service-near-payin.component.scss']
})
export class ServiceNearPayinComponent implements OnInit {
  payInForm!: FormGroup;
  usersList: any[] = [];
  showPaymentModesModal: boolean = false;
  calledFrom: string = 'pay-in';
  paymentInfo:any;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  loading: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private fb: FormBuilder,
    private adminService: AdminService,
  ) { }

  ngOnInit(): void {
    this.populateToolbarData();
    this.getUserList();
    this.setAllForms();
  }

  public handlePaymentModalClose() {
    this.showPaymentModesModal = false;
  }

  public handlePaymentSaved(event: { paymentModes: any[]; totalAmount: number; changeToReturn: number; calledFrom: string }) {
    const paymentModesString = JSON.stringify(event.paymentModes);
    const change = event.changeToReturn;
    const totalReceivedAmount = event.totalAmount;
    this.paymentInfo = {
      change,
      paymentModesString,
      totalReceivedAmount,
    }
    
    this.onSubmit();
  }

  public openPaymentModal() {
    this.showPaymentModesModal = true;
  }

  get customer() {
    return this.payInForm.get('customer');
  }

  get amount() {
    return this.payInForm.get('amount');
  }

  onSubmit(): void {
    if (this.payInForm.valid) {
      this.loading = true;
      const FirstName = this.customer?.value.FirstName || '';
      const LastName = this.customer?.value.LastName || '';
      let params: any = {
        customerName: FirstName + " " + LastName,
        customerID: this.customer?.value.ID,
      }
      params['orderId'] =  0;
      params['totalAmount'] = this.paymentInfo.totalReceivedAmount;
      params['paymentModes'] = this.paymentInfo.paymentModesString || '';

      this.adminService.saveTransactionByConfiguration(params).subscribe((res: any) => {

        if (res?.Result == "Success") {
          this.notify(true, 'Pay in successful');
          this.payInForm.reset();
        }
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.notify(false, 'Pay in failed. Try again');
        this.loading = false;
      });

    } else {
      this.payInForm.markAllAsTouched();
    }
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Pay In',
    });

    this.layoutService.setNavbarButtons([]);
  }

  private setAllForms() {
    this.payInForm = this.fb.group({
      customer: [null, [Validators.required]],
      amount: ['', [Validators.required, Validators.min(0.01)]],
    });
  }

  private getUserList() {
    let params = {
      takeAll: false,
      skip: 0,
      take: 100,
      keyWord: '',
      isDateChecked: false,
      fromDate: null,
      toDate: null,
      userType: 'user,shop',
    };
    this.adminService.getUsersAndShopsForAdmin(params).subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData) {
        this.usersList = res.ResponseData;
      }
    }, (err: HttpErrorResponse) => {

    });
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }
}
